// ----------------------------------------------------------------------
// <copyright file="Izenda.GridCellState.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------
!(function() {
  var action = require('mobx').action;
  var extendObservable = require('mobx').extendObservable;
  const { floor } = require('lodash/fp');

  function GridCellState(cellWidth, cellHeight, leftPadding, rightPadding, transparent) {
    extendObservable(this, {
      cellWidth: cellWidth,
      cellHeight: cellHeight,
      leftPadding: leftPadding || 0,
      rightPadding: rightPadding || 0,
      hoverCellTop: -1,
      hoverCellLeft: -1,
      isHover: false,
      isMenuVisible: false,
      transparent: !!transparent
    });
  }

  GridCellState.prototype.setTransparent = action(function(transparent) {
    this.transparent = !!transparent;
  });

  GridCellState.prototype.setMenuVisible = action(function(isVisible) {
    this.isMenuVisible = isVisible;
  });

  GridCellState.prototype.updateDimension = action(function(cellWidth, cellHeight, leftPadding, rightPadding) {
    this.cellWidth = cellWidth;
    this.cellHeight = cellHeight;
    this.leftPadding = leftPadding || 0;
    this.rightPadding = rightPadding || 0;
  });

  GridCellState.prototype.getCellLineStyle = function(width, height, isRenderCellBorder) {
    return {
      left: this.leftPadding,
      height: Math.round(height / this.cellHeight) * this.cellHeight,
      width: Math.round(width / this.cellWidth) * this.cellWidth + 1,
      backgroundSize: isRenderCellBorder ? String.format('{0}px {1}px, {0}px {1}px', this.cellWidth, this.cellHeight) : null,
      backgroundColor: this.transparent ? 'transparent' : undefined
    };
  };

  GridCellState.prototype.getAddButtonCellStyle = function() {
    return {
      width: this.cellWidth + 'px',
      height: this.cellHeight + 'px',
      left: this.hoverCellLeft + 'px',
      top: this.hoverCellTop + 'px',
      position: 'absolute',
      display: this.isHover ? 'block' : 'none'
    };
  };

  GridCellState.prototype.getAddButtonMenuStyle = function() {
    return {
      position: 'absolute',
      display: 'block',
      left: `${this.hoverCellLeft + this.cellWidth}px`,
      top: `${this.hoverCellTop}px`
    }
  }

  GridCellState.prototype.resetPosition = action(function() {
    this.hoverCellLeft = -1;
    this.hoverCellTop = -1;
    this.isHover = false;
  });

  GridCellState.prototype.onPosition = action(function(x, y, hover) {
    var snappedPos = this.snapToCellGrid(x, y);
    this.hoverCellLeft = snappedPos.x;
    this.hoverCellTop = snappedPos.y;
    this.isHover = hover;
  });

  /**
   * Get position of hover cell in grid scale
   */
  GridCellState.prototype.getHoverCellPosition = function() {
    return {
      x: floor(this.hoverCellLeft / this.cellWidth),
      y: floor(this.hoverCellTop / this.cellHeight)
    };
  };

  GridCellState.prototype.snapToCellGrid = function(x, y) {
    var slackX = this.cellWidth > 0 ? x % this.cellWidth : x;
    var slackY = this.cellHeight > 0 ? y % this.cellHeight : y;
    return {
      x: x + (this.leftPadding || 0) - slackX,
      y: y - slackY
    };
  };

  GridCellState.prototype.isCurrentCell = function(x, y) {
    var snappedPos = this.snapToCellGrid(x, y);
    return this.hoverCellLeft === snappedPos.x && this.hoverCellTop === snappedPos.y;
  };

  module.exports = GridCellState;
})();



// WEBPACK FOOTER //
// ./ui/share/components/controls/GridLayout/Izenda.GridCellState.js